// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"b3af712a","453":"1c56359f","454":"7037bb0d","702":"4fc0084e"}[chunkId] + ".chunk.js";
};